import { Role } from '../../generated/graphql';

/**
 * Who may open the Stone mode screens (YOJO-3259) — routes, the Tools tab and the sidebar all read this one list.
 * Who may change them, and what "coach" means here: hooks/useStoneModeAccess.ts.
 */
export const STONE_MODE_READ_ROLES: Role[] = [Role.Admin, Role.Nurse, Role.Operations];
